export { default } from './UserMobileMenuLink';



// WEBPACK FOOTER //
// ./src/components/base/UserMobileMenuLink/index.js